import PropTypes from 'prop-types';
import React, { Component } from 'react';
import utilities from './../../../utils/utilities';
import ReactPaginate from 'react-paginate';

export default function withPagination(CollectionComponent) {
    class Paginated extends Component {
        static propTypes = {
            listItems: PropTypes.array,
            itemCount: PropTypes.number,
            loadItems: PropTypes.func,
            isFinished: PropTypes.bool,
            withPromise: PropTypes.bool
        }

        static defaultProps = {
            isFinished: false,
            withPromise: true
        }

        constructor(props) {
            super(props);
            this.goToPage = this.goToPage.bind(this);
            this.state = {
                pendingRequest: false
            }
        }

        componentDidMount() {
            this._isMounted = true;
        }

        /**
         * Setter for pendingRequest in state
         * @param value
         * @returns {Scrollable}
         */
        setPendingRequest(value) {
            if (!this._isMounted) return;
            this.setState({ pendingRequest: value });
            return this;
        }

        /**
         * General function for loading items
         * @param params
         */
        loadItems(params = null) {
            params = {
                ...params,
                reset: true
            };
            if (!this.state.pendingRequest) {
                if (this.props.withPromise) {
                    this.setPendingRequest(true);
                    return this.props.loadItems(params).then(response => {
                        this.setPendingRequest(false);
                        return response;
                    })
                } else {
                    this.props.loadItems(params);
                }
            }
        }

        goToPage(page) {
            this.loadItems({ pagination: { pageNumber: page.selected } })
        }

        render() {
            const totalPages = Math.ceil(this.props.itemCount / this.props.loadParams.pagination.pageSize);
            return (
                <div className={"scrollable "}>
                    <CollectionComponent {...this.props} headerWidth={this.state.headerWidth} />
                    { this.props.listItems !== null && this.props.listItems.length > 0 &&
                    <ReactPaginate pageCount={totalPages}
                                   marginPagesDisplayed={1}
                                   pageRangeDisplayed={4}
                                   containerClassName={"pagination"}
                                   initialPage={this.props.loadParams.pagination.pageNumber}
                                   disableInitialCallback={true}
                                   onPageChange={this.goToPage}
                                   nextLabel={<span className='la-TriangleRight' />}
                                   previousLabel={<span className='la-TriangleLeft' />}
                    />
                    }
                </div>
            )
        }
    }

    Paginated.displayName = `Paginated(${utilities.getDisplayName(CollectionComponent)})`;
    return Paginated;
}



// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/hoc/Paginated.jsx